import SFetch from '@app/utils/sfetch'

type UpdateParams = {
  id: number
  title?: string
  summary?: string
  completedAt?: string | null
  order?: string[]
  pastedNotes?: string
  signal?: AbortSignal
}

export async function update(updateParams: UpdateParams): Promise<void> {
  const url = window.Silverfin.Routes.client_meeting_path(
    window.Silverfin.currentFirmId,
    window.Silverfin.currentCompanyId,
    updateParams.id
  )

  const { title, summary, completedAt, order, pastedNotes, signal } =
    updateParams
  const payload = {
    ...(title !== undefined && { title }),
    ...(summary !== undefined && { summary }),
    ...(completedAt !== undefined && { completed_at: completedAt }),
    ...(order !== undefined && { order }),
    ...(pastedNotes !== undefined && { pasted_notes: pastedNotes }),
  }

  await SFetch.json(url, {
    method: 'PATCH',
    body: { client_meeting: payload },
    signal,
  })
}

async function deleteMeeting(meetingId: number): Promise<void> {
  const url = window.Silverfin.Routes.client_meeting_path(
    window.Silverfin.currentFirmId,
    window.Silverfin.currentCompanyId,
    meetingId
  )

  await SFetch.raw(url, {
    method: 'DELETE',
  })
}

export { deleteMeeting as delete }

export async function generateExport(
  clientMeetingId: number
): Promise<{ url: string } | null> {
  const url = window.Silverfin.Routes.export_client_meeting_path(
    window.Silverfin.currentFirmId,
    window.Silverfin.currentCompanyId,
    { id: clientMeetingId }
  )

  return await SFetch.json(url, {
    method: 'POST',
  })
}
